import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-live",
  "use": "icon-live-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-live\"><defs><style type=\"text/css\"></style></defs><path d=\"M634.88 235.52c56.55552 0 102.4 45.84448 102.4 102.4v353.28c0 56.55552-45.84448 102.4-102.4 102.4H189.44c-56.55552 0-102.4-45.84448-102.4-102.4V337.92c0-56.55552 45.84448-102.4 102.4-102.4h445.44zM210.69312 289.70496h-6.88128c-28.27776 0-51.2 22.92224-51.2 51.2v5.9648c0 28.27264 22.92224 51.2 51.2 51.2h6.88128c28.27776 0 51.2-22.92736 51.2-51.2v-5.9648c0-28.27776-22.92224-51.2-51.2-51.2zM768.0256 397.19424l104.84224-71.74144A40.96 40.96 0 0 1 936.96 359.25504v321.14176a40.96 40.96 0 0 1-64.09216 33.80224l-104.87808-71.76192 0.03584-245.24288z\" p-id=\"3686\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/live.svg
// module id = ZkmS
// module chunks = 112